import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkuSummaryComponent } from './sku-summary.component';
import { SharedUiModule } from '@emi/shared/ui';
import { SkuCapsuleUiModule } from '@emi/sku-capsule/ui';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    SharedUiModule,
    SkuCapsuleUiModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    SkuSummaryComponent
  ],
  exports: [
    SkuSummaryComponent
  ],
})
export class SkuCapsuleFeatureSkuSummaryModule {}
